import Text from "common/Typography/Text.tsx";
import React from "react";
import Flex from "common/Boxes/Flex.tsx";
import Switch from "common/Buttons/Switch.tsx";
import useDisableToggles from "features/bots/BotForm/OperationHours/hooks/useDisableToggles.ts";

const DisableToggles = () => {
  const { isWeekendDisabled, isNightsDisabled, toggleWeekend, toggleNights } =
    useDisableToggles();

  return (
    <Flex style={{ flexDirection: "column", rowGap: 20 }}>
      <Flex style={{ width: "100%" }}>
        <Text>Disable Weekends</Text>
        <Switch
          checked={isWeekendDisabled}
          onClick={toggleWeekend}
          size="small"
        />
      </Flex>
      <Flex style={{ width: "100%" }}>
        <Text>Disable Nights</Text>
        <Switch
          checked={isNightsDisabled}
          onClick={toggleNights}
          size="small"
        />
      </Flex>
    </Flex>
  );
};

export default DisableToggles;
